<template>
  <div class="d-flex flex-column align-center justify-center">
    <div class="text-center">
      <div class="d-flex flex-row">
        <v-icon size="50" color="red">mdi-alert</v-icon>
        <h1 style="font-size: 55px">404</h1>
      </div>
      <hr style="border-top: 2px solid red" />
      <i style="font-size: 20px">Page Not Found</i>
    </div>
  </div>
</template>

<script>
export default {};
</script>
